import React, { Fragment, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import WarehousePreferences from "./WarehousePreferences";

const WarehouseRulesModal = ({ show, onClose, currentUser, editUser, customerCode }) => {
    const cancelButtonRef = useRef(null);

    useEffect(() => {
        if (show && cancelButtonRef.current) {
            cancelButtonRef.current.focus();
        }
    }, [show]);

    return (
        <Transition.Root show={show} as={Fragment} className="" >
            <Dialog
                as="div"
                className="relative z-10 "
                initialFocus={cancelButtonRef}
                onClose={onClose}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 mt-[120px] overflow-y-auto">
                    <div className="flex min-h-full items-start justify-center p-4 text-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative overflow-hidden rounded-lg bg-white p-6 shadow-xl sm:max-w-5xl w-full mt-[100px]">
                                <button
                                    type="button"
                                    ref={cancelButtonRef}
                                    className="sr-only"
                                    onClick={onClose}
                                >
                                    Close
                                </button>
                                <WarehousePreferences
                                    customerCode={customerCode}
                                    onClose={onClose}
                                    currentUser={currentUser}
                                    editUser={editUser}
                                />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default WarehouseRulesModal;
